export { default } from './Residence';
export { default as datamap } from './Residence.datamap';
export type { PageData } from './Residence.datamap';
